/**
 * Old unformatted code that should be rewritten, temporary
 * TODO: if file exists - we have code to refactor
 *
 * @copyright 2018 Linguistica 360
 */

export function binParse(text, errorRet) {
	var errRet = 0;
	text = text.replace(/({+)(.+?)(}+)/gi, function(match, b1, t, b2) {
		var s = t.match(/=/g)
		var tt = t.split('=');
		if(tt.length == 2) {
			var l = tt[0].trim();
			var r = tt[1].trim();
		}
		if(b1.length == 1 && b2.length == 1 && s && s.length == 1 && tt.length == 2 && l.length && r.length) {
			return '<span data-tooltip="correct" style="color: green;">'+match+'</span>';
		}
		else {
			var errors = ['The pattern is probably broken'];
			errRet++;
			if(!s) {
				errors.push('No \'=\' sign found');
			}
			if(s && s.length > 1) {
				errors.push('Too many \'=\'');
			}
			if(s && s.length == 1) {
				if(!l.length) errors.push('Nothing to translate');
				if(!r.length) errors.push('No translation');
			}
			if(b1.length > 1) {
				errors.push('Too many opening brackets');
			}
			if(b2.length > 1) {
				errors.push('Too many closing brackets');
			}
			return '<span data-tooltip="'+errors.join('<br/>')+'" style="color: red;">'+match+'</span>';
		}
	});
	text = text.replace(/({+)([^\n\r{]+)/gi, function(match, b1, t) {
		if(t.search('}') === -1) {
			errRet++;
			var errors = ['The pattern is probably broken'];
			errors.push('No closing bracket');
			t = match.split('=');
			if(b1.length > 1) errors.push('Too many opening brackets');
			return '<span data-tooltip="'+errors.join('<br/>')+'" style="color: red;">'+t[0]+'</span>'+(t.length > 1 ? '='+t[1] : '');
		}
		else return match;
	});
	text = text.replace(/([^\n\r]+?)(}+)/gi, function(match, t, b2) {
		if(t.search('{') === -1) {
			errRet++;
			var errors = ['The pattern is probably broken'];
			errors.push('No opening bracket');
			t = t.split('=');
			if(b2.length > 1) errors.push('Too many closing brackets');
            return t[0] +'<span data-tooltip="'+errors.join('<br/>')+'" style="color: red; font-weight: bold;">'+(t.length > 1 ? '='+t[1] : '')+'}</span>';
		}
		else return match;
	});
	return errorRet ? errRet : text;
}

function removeCurlies(str) {
    return str.replace(/[\u2018\u2019’‘]/g, "'").replace(/[\u201C\u201D]/g, '"');
}

// quizzes

function validation(id, correct)
{
var value=document.getElementById(id).value.toUpperCase();
correct = correct.toUpperCase();
value = value.trim();
value = removeCurlies(value);

if (correct==value)
{
    document.getElementById(id).className="quiz-item-correct";
}
else
{
    document.getElementById(id).className="quiz-item-incorrect";
}
if (value=="")
{
    document.getElementById(id).className="";
}
}

function validationNs(id, shown, answers) {

var value=document.getElementById(id).value.toUpperCase();
value = value.trim();
value = removeCurlies(value);

var correct1 = answers.slice();
var correct2 = shown.slice();

// convert all Correct values to upper case

var correct_answer_found = 0;
for(var i=0; i < correct1.length; i++) {
  correct1[i] = correct1[i].toUpperCase();
  correct2[i] = correct2[i].toUpperCase();

  if (correct1[i]==value  || correct2[i]==value) {
    document.getElementById(id).className="quiz-item-correct";
    if (shown[i] != '') {
      document.getElementById(id).value=shown[i];
    }
    correct_answer_found = 1;
    break;
  }
}

if (correct_answer_found == 1) {
    document.getElementById(id).className="quiz-item-correct";
}
else
{
    document.getElementById(id).className="quiz-item-incorrect";
}
if (value=="")
{
    document.getElementById(id).className="";
}
}

function validation2(id, correct1, correct2)
{
var value=document.getElementById(id).value.toUpperCase();
correct1 = correct1.toUpperCase();
correct2 = correct2.toUpperCase();
value = value.trim();
value = removeCurlies(value);

if (correct1==value || correct2==value)
{
    document.getElementById(id).className="quiz-item-correct";
}
else
{
    document.getElementById(id).className="quiz-item-incorrect";
}
if (value=="")
{
    document.getElementById(id).className="";
}
}

function validation3(id, correct1, correct2, correct3)
{
var value=document.getElementById(id).value.toUpperCase();
correct1 = correct1.toUpperCase();
correct2 = correct2.toUpperCase();
correct3 = correct3.toUpperCase();
value = value.trim();
value = removeCurlies(value);

if (correct1==value || correct2==value || correct3==value)
{
    document.getElementById(id).className="quiz-item-correct";
}
else
{
    document.getElementById(id).className="quiz-item-incorrect";
}
if (value=="")
{
    document.getElementById(id).className="";
}
}

function validation4(id, correct1, correct2, correct3, correct4)
{
var value=document.getElementById(id).value.toUpperCase();
correct1 = correct1.toUpperCase();
correct2 = correct2.toUpperCase();
correct3 = correct3.toUpperCase();
correct4 = correct4.toUpperCase();
value = value.trim();
value = removeCurlies(value);

if (correct1==value || correct2==value || correct3==value || correct4==value)
{
    document.getElementById(id).className="quiz-item-correct";
}
else
{
    document.getElementById(id).className="quiz-item-incorrect";
}
if (value=="")
{
    document.getElementById(id).className="";
}
}

function validation4s(id, shown, correct1, correct2, correct3, correct4)
{
var original_value=document.getElementById(id).value;
var value=document.getElementById(id).value.toUpperCase();
correct1 = correct1.toUpperCase();
correct2 = correct2.toUpperCase();
correct3 = correct3.toUpperCase();
correct4 = correct4.toUpperCase();
value = value.trim();
value = removeCurlies(value);

if (correct1==value || correct2==value || correct3==value || correct4==value || shown==original_value)
{
    document.getElementById(id).className="quiz-item-correct";
    document.getElementById(id).value=shown;
}
else
{
    document.getElementById(id).className="quiz-item-incorrect";
}
if (value=="")
{
    document.getElementById(id).className="";
}
}

function validation2s(id, shown, correct1, correct2)
{
var original_value=document.getElementById(id).value;
var value=document.getElementById(id).value.toUpperCase();
correct1 = correct1.toUpperCase();
correct2 = correct2.toUpperCase();
value = value.trim();
value = removeCurlies(value);
if (correct1==value || correct2==value || shown==original_value)
{
    document.getElementById(id).className="quiz-item-correct";
    document.getElementById(id).value=shown;
}
else
{
    document.getElementById(id).className="quiz-item-incorrect";
}
if (value=="")
{
    document.getElementById(id).className="";
}
}

window.validation = validation;
window.validationNs = validationNs;
window.validation2 = validation2;
window.validation2s = validation2s;
window.validation3 = validation3;
window.validation4 = validation4;
window.validation4s = validation4s;
